// @create-index

export { default as createTheme } from './createTheme.js';

